<template>
  <div class="complex-table" ref="body">
    <!-- 表头 -->
    <slot name="header">
      <el-row class="table-header" type="flex">
        <el-col class="text-left" v-for="column in normalColumns" :key="column.prop" :class="column.class" :style="{width: (column.width ? column.width : defaultWidth + 'px')}">{{column.label}}</el-col>
        <el-col class="text-left" v-for="column in collapseColumns" :key="column.prop" :class="column.class" :style="{width: (column.width ? column.width : defaultWidth + 'px')}">{{column.label}}</el-col>
      </el-row>
    </slot>
    <!-- 表体 -->
    <div class="table-body">
      <div class="sub-row-table" v-for="(item, $index) in data" type="flex" :key="$index">
        <el-row class="sub-header" type="flex" justity="space-between">
          <slot name="sub-header" :row="item" :index="$index"></slot>
        </el-row>
        <el-row class="sub-body" type="flex">
          <el-col class="table" style="width: auto">
            <el-table :data="item[config.dataPrefix]" :show-header="false" style="height: 100%">
              <el-table-column v-for="column in normalColumns" :key="column.prop" :width="column.width ? column.width : defaultWidth + 'px'">
                <template scope="props">
                  <slot v-if="column.slot" :name="column.slot" :row="props.row" :parent-row="item" :index="$index"></slot>
                  <template v-else>{{props.row[column.prop]}}</template>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col v-for="column in collapseColumns" :key="column.prop" :class="[column.class, 'collapse-column']" :style="{width: (column.width ? column.width : defaultWidth + 'px')}">
            <slot :name="column.key" :row="item" :index="$index"></slot>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: [],
    },
  },
  computed: {
    collapseColumns() {
      return this.config.column.filter(item => item.collapse)
    },
    normalColumns() {
      return this.config.column.filter(item => !item.collapse)
    },
  },
  data() {
    return {
      hiddenActionBar: false,
      actionBarWidth: 0,
      defaultWidth: 0,
      slotName: 'action-bar',
    }
  },
  mounted() {
    let totalWidth = this.$refs['body'].clientWidth
    let noWidthCount = 0
    this.config.column.forEach(column => {
      if (column.width) {
        totalWidth -= parseInt(column.width)
      } else {
        noWidthCount++
      }
    })
    this.defaultWidth = totalWidth / noWidthCount
  },
}
</script>

<style lang="less" scoped>
.complex-table {
  .table-body {
    min-height: 60px;
  }
  .table-header {
    height: 42px;
    line-height: 42px; // padding-left: 18px;
    // padding-right: 18px;
    background: #fff;
    font-weight: bold;
    text-align: left;
    &>.el-col {
      padding-left: 15px;
    }
  }
  .sub-row-table {
    margin-bottom: 10px;
    .sub-header {
      height: 47px;
      line-height: 47px;
      background-color: #e5e9f2;
      padding: 0 18px;
      font-size: 12px;
    }
    .sub-body {
      >.el-col {
        background: #fff;
      }
       :last-child {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-top: 1px solid #dfe6ec;
        border-right: 1px solid #dfe6ec;
        border-bottom: 1px solid #dfe6ec;
      }
    }
  }
}

.collapse-column1 {
  display: inline-block;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// ComplexGrid.vue?60ddf47b